import {useState} from 'react';
import {useTheme} from '@mui/material';
import NavContent from './components/NavContent';

import type {Props} from './types';

const Nav = (props: Props) => {
  const {
    showCourses,
    tabsList,
    courses,
    courseLink,
    selectedNav,
    toShowSelect,
    showPremium,
  } = props || {};
  const theme = useTheme();
  const [selected, setSelected] = useState(0);
  const [moreMenu, setMoreMenu] = useState(0);
  const [value, setValue] = useState(0);
  const [open, setOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);

  const handleOnClick = (event: React.SyntheticEvent, value: number): void => {
    setSelected(value);
  };

  const handleTabChange = (
    event: React.SyntheticEvent,
    value: number
  ): void => {
    setValue(value);
  };

  const handleMenuOpen = (event: React.BaseSyntheticEvent, value: number) => {
    const {currentTarget} = event;
    setOpen(true);
    setAnchorEl(currentTarget);
    setMoreMenu(0);
    setValue(value);
  };

  const handleMoreMenuOpen = (
    event: React.BaseSyntheticEvent,
    value: number
  ) => {
    const {currentTarget} = event;
    setOpen(true);
    setAnchorEl(currentTarget);
    setMoreMenu(value);
    setValue(value);
  };

  const handleMenuClose = () => {
    setOpen(false);
    setAnchorEl(null);
    setMoreMenu(0);
    setValue(-1);
  };

  return (
    <div style={{display: 'flex'}}>
      <NavContent
        showCourses={showCourses}
        tabsList={tabsList}
        courses={courses}
        theme={theme}
        open={open}
        anchorEl={anchorEl}
        selected={selected}
        moreMenu={moreMenu}
        value={value}
        courseLink={courseLink}
        showPremium={showPremium}
        selectedNav={selectedNav}
        toShowSelect={toShowSelect}
        handleMenuOpen={handleMenuOpen}
        handleMoreMenuOpen={handleMoreMenuOpen}
        handleMenuClose={handleMenuClose}
        handleTabChange={handleTabChange}
        handleOnClick={handleOnClick}
      />
    </div>
  );
};

export default Nav;
